import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      rating: 5,
      title: "Best Online Fashion Site",
      text: "I'm so happy with the products and services. All the Lorem ipsum fashion style.",
      author: "Robert Smith",
      time: "3 minutes ago",
      source: "Etsy"
    },
    {
      rating: 5,
      title: "Great Selection and Quality",
      text: "I'm so happy with the products and i find your website and quality of the fashion site.",
      author: "Allen Lyn",
      time: "5 minutes ago",
      source: "Fiverr"
    },
    {
      rating: 5,
      title: "Best Customer Service",
      text: "I totally found it was friendly easy to the shopping website. Great work in the Site.",
      author: "Peter Rope",
      time: "2 minutes ago",
      source: "Trustpilot"
    }
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-2">Happy Clients</h2>
          <p className="text-gray-600">Satisfied Shoppers Share Their Style Wins</p>
        </div>

        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
                <div className="flex items-center space-x-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="text-yellow-400">★</span>
                  ))}
                </div>
                <h3 className="font-bold mb-2">{testimonial.title}</h3>
                <p className="text-gray-600 text-sm mb-4">{testimonial.text}</p>
                <div className="border-t pt-4">
                  <p className="font-semibold text-sm">{testimonial.author}</p>
                  <p className="text-xs text-gray-500">{testimonial.time}</p>
                  <p className="text-xs text-gray-400 mt-1">Published from {testimonial.source}</p>
                </div>
              </div>
            ))}
          </div>

          <button className="absolute -left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition hidden md:flex">
            <ChevronLeft size={20} />
          </button>
          <button className="absolute -right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition hidden md:flex">
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
